import { computed } from 'vue'
import { useStorage } from '@vueuse/core'

function toBase64 (bytes) {
  let bin = ''
  bytes.forEach((b) => (bin += String.fromCharCode(b)))
  return btoa(bin)
}
function fromBase64 (b64) {
  const bin = atob(b64)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return bytes
}
function xorBytes (bytes, keyBytes) {
  const out = new Uint8Array(bytes.length)
  for (let i = 0; i < bytes.length; i++) out[i] = bytes[i] ^ keyBytes[i % keyBytes.length]
  return out
}
function encodeClient (client, secret) {
  const json = JSON.stringify(client)
  const encoder = new TextEncoder()
  const data = encoder.encode(json)
  const key = encoder.encode(secret)
  return toBase64(xorBytes(data, key))
}
function decodeClient (encoded, secret) {
  const decoder = new TextDecoder()
  const encoder = new TextEncoder()
  const key = encoder.encode(secret)
  const data = xorBytes(fromBase64(encoded), key)
  return JSON.parse(decoder.decode(data))
}

function getTodayKey () {
  const d = new Date()
  const yyyy = String(d.getFullYear())
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

// Implementation for the purposes of the PoC — the final solution will be on the API side
export function useDailyClientQueue (enabled = false, business) {
  const secret = 'tt-f1045612-9d39-4a1a-be96-e1de28225330' // remove this from .gitleaks after PoC
  const keyPrefix = 'tt-client-queue:daily'

  const storageKey = `${keyPrefix}:biz:${business}`

  if (!enabled) {
    try { localStorage.removeItem(storageKey) } catch {}

    return {
      add: () => null,
      peek: () => null,
      removeFirst: () => false,
    }
  }

  const persisted = useStorage(storageKey, { day: getTodayKey(), items: [] }, localStorage, {
    mergeDefaults: true,
  })

  function ensureToday () {
    const today = getTodayKey()

    if (!persisted.value || typeof persisted.value !== 'object') {
      persisted.value = { day: today, items: [] }
      return
    }

    if (persisted.value.day !== today) {
      persisted.value = { day: today, items: [] }
      return
    }

    if (!Array.isArray(persisted.value.items)) {
      persisted.value.items = []
    }
  }

  function add (client) {
    ensureToday()
    persisted.value.items.push(encodeClient(client, secret))
  }

  function peek () {
    ensureToday()
    const encoded = persisted.value.items[0]
    if (!encoded) return null
    try { return decodeClient(encoded, secret) } catch { return null }
  }

  function removeFirst () {
    ensureToday()
    if (!persisted.value.items.length) return false
    persisted.value.items.shift()
    return true
  }

  return {
    add,
    peek,
    removeFirst,
  }
}
